// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FormInputFile_formInputFile__OMaCR {\n  display: none;\n}", "",{"version":3,"sources":["webpack://./src/components/form/form-input-file/FormInputFile.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;AACD","sourcesContent":[".formInputFile {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formInputFile": "FormInputFile_formInputFile__OMaCR"
};
export default ___CSS_LOADER_EXPORT___;
